import React, { useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { UseAuthContext } from "../../store/contexts/auth.context";
import Box from "../../UI/Box";
import Container from "../../UI/Container";
import user from "../../images/user.webp";

function EditProfile() {
  const { data, updateAccount } = UseAuthContext();
  const navigate = useNavigate();
  const [values, setvalues] = useState({
    first_name: data.first_name,
    second_name: data.second_name,
    nickname: data.nickname,
    bio: data.bio,
    email: data.email,
    phone: data.phone,
    city: data.city,
  });
  const { uploadPhoto } = UseAuthContext();
  const imageHandler = (e) => {
    const image = e.target.files[0];
    const formData = new FormData();
    formData.append("file", image);
    uploadPhoto(formData);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    await updateAccount({
      bio: values.bio,
      city: values.city,
      email: "",
      first_name: values.first_name,
      interests: [],
      nickname: values.nickname !== data.nickname ? values.nickname : null,
      password: "",
      phone: values.phone,
      second_name: values.second_name,
    });
    navigate("/profile");
  };
  return (
    <Wrapper>
      <Container>
        <h1 className="main-title flex between">
          <div className="flex start">Edit Profile</div>
          <NavLink to={"/profile"} className="tag edit flex align-center">
            <h2 className="flex">
              <img
                src="https://img.icons8.com/ios-glyphs/30/718096/back.png"
                width={20}
              />
              Back
            </h2>
          </NavLink>
        </h1>
        <Box animation={false}>
          <div className="top-row">
            <div className=" flex image">
              <div
                className="img flex"
                style={{
                  backgroundImage: `url(${
                    data.account_image_path.String || user
                  })`,
                }}
              >
                <label>
                  <img src="https://img.icons8.com/ios/50/ffffff/camera--v3.png" />
                  <input
                    onChange={imageHandler}
                    type="file"
                    style={{ display: "none" }}
                  />
                </label>
              </div>
            </div>{" "}
            <div className="row">
              <div className="form-group">
                <label>First name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="First name"
                  value={values.first_name}
                  onChange={(e) =>
                    setvalues((p) => ({ ...p, first_name: e.target.value }))
                  }
                />
              </div>
              <div className="form-group">
                <label>Last name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Last name"
                  value={values.second_name}
                  onChange={(e) =>
                    setvalues((p) => ({ ...p, second_name: e.target.value }))
                  }
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label>Bio</label>
              <input
                value={values.bio}
                type="text"
                className="form-input"
                placeholder="Bio"
                onChange={(e) =>
                  setvalues((p) => ({ ...p, bio: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                className="form-input"
                placeholder="Location"
                value={values.city}
                onChange={(e) =>
                  setvalues((p) => ({ ...p, city: e.target.value }))
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label>Nickname</label>
              <input
                type="text"
                className="form-input"
                placeholder="Nickname"
                value={values.nickname}
                onChange={(e) =>
                  setvalues((p) => ({ ...p, nickname: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                className="form-input"
                placeholder="Email Address"
                value={values.email}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label>Phone number</label>
              <input
                type="text"
                className="form-input"
                placeholder="Phone number"
                value={values.phone}
                onChange={(e) =>
                  setvalues((p) => ({ ...p, phone: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>Are you sure to save?</label>
              <input
                type="submit"
                onClick={submitHandler}
                className="form-input"
                value="Save"
              />
            </div>
          </div>
        </Box>
        <div className="devider"></div>
      </Container>
    </Wrapper>
  );
}

export default EditProfile;
const Wrapper = styled.main`
  & > div > div {
    padding: 40px;
    @media (max-width: 767px) {
      padding: 30px;
    }
  }
  .main-title {
    margin-bottom: 40px;
  }
  .top-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 40px;
    }
    gap: 20px;
    & > div {
      width: 100%;
    }
    .row {
      grid-template-columns: 1fr;
      grid-gap: 0px;
      input {
        margin-bottom: 0px !important;
        @media (max-width: 767px) {
          margin-bottom: 12px !important;
        }
      }
    }
  }
  label {
    z-index: 2;
  }
  .image {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 180px;
      left: 50%;
      bottom: 50%;
      transform: translate(-45%, 55%);
      height: 180px;
      border-radius: 50% 20%;
      z-index: 1;
      background-color: #bfc6cf;
    }
  }
  .img {
    z-index: 2;
    position: relative;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      background-color: #00000000;
      transition: all 0.3s;
    }
    &:hover {
      &::after {
        background-color: #000000a4;
      }
      img {
        opacity: 1;
      }
    }
    img {
      transition: all 0.3s;
      opacity: 0;
      z-index: 2;
      cursor: pointer;
      width: 36px;
      transform: scale(1);
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  .row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
    margin-bottom: 10px;
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      grid-gap: 0px;
      margin-bottom: 0px;
    }
  }
`;
